export type TBrandsName =
  | 'local'
  | 'zali'
  | 'miliuat'
  | 'miliqa'
  | 'mili'
  | 'finnvo'
  | 'bancaliv'
  | 'creditoo'
  | 'inversiones'
  | 'fie'
  | 'fibanca'
  | 'fondo'
  | 'tusolucion'
  | 'credipress'
  | 'liberate'
  | 'nauw'
  | 'lenddi'
  | 'credinver'
  | 'freend'
  | 'gym'
  | 'maxcredit'
  | 'sofi'
  | 'libramoneda'
  | 'quickbank'
  | 'fembisol'
  | 'finanzas'
  | 'crecevalor'
  | 'suvalor'
  | 'finzap'
  | 'mifianza'
  | 'procord'
  | 'resuelveya'
  | 'socialcredit'
  | 'cxc'
  | 'banvi'
  | 'hazloya'
  | 'pys'
  | 'netwifi'
  | 'credyfast'
  | 'valit'
  | 'oportunidades'
  | 'meloncash'
  | 'trufi'
  | 'finanz'
  | 'logicash'
  | 'krennova';

export const selectClientName: () => TBrandsName = () => {
  const client = window.location.hostname;
  if (client.includes('localhost')) {
    return 'local';
  }
  if (client.includes('banvi')) {
    return 'banvi';
  }
  if (client.includes('oportunidades')) {
    return 'oportunidades';
  }
  if (client.includes('meloncash')) {
    return 'meloncash';
  }
  if (client.includes('inversiones')) {
    return 'inversiones';
  }
  if (client.includes('procord')) {
    return 'procord';
  }
  if (client.includes('resuelveya')) {
    return 'resuelveya';
  }
  if (client.includes('finzap')) {
    return 'finzap';
  }
  if (client.includes('mifianza')) {
    return 'mifianza';
  }
  if (client.includes('fembisol')) {
    return 'fembisol';
  }
  if (client.includes('suvalor')) {
    return 'suvalor';
  }
  if (client.includes('crecevalor')) {
    return 'crecevalor';
  }
  if (client.includes('zali')) {
    return 'zali';
  }
  if (client.includes('demo')) {
    return 'miliqa';
  }
  if (client.includes('uat')) {
    return 'miliuat';
  }
  if (client.includes('mili')) {
    return 'mili';
  }
  if (client.includes('finnvo')) {
    return 'finnvo';
  }
  if (client.includes('bancaliv')) {
    return 'bancaliv';
  }
  if (client.includes('creditoo')) {
    return 'creditoo';
  }
  if (client.includes('fie')) {
    return 'fie';
  }
  if (client.includes('fibanca')) {
    return 'fibanca';
  }
  if (client.includes('finanzas')) {
    return 'finanzas';
  }
  if (client.includes('finanz')) {
    return 'finanz';
  }
  if (client.includes('elbancodelagente')) {
    return 'fondo';
  }
  if (client.includes('tusolucion')) {
    return 'tusolucion';
  }
  if (client.includes('credipress')) {
    return 'credipress';
  }
  if (client.includes('liberate')) {
    return 'liberate';
  }
  if (client.includes('nauwcolombia')) {
    return 'nauw';
  }
  if (client.includes('lenddi')) {
    return 'lenddi';
  }
  if (client.includes('credinver')) {
    return 'credinver';
  }
  if (client.includes('freend')) {
    return 'freend';
  }
  if (client.includes('gmserviciosfinancieros')) {
    return 'gym';
  }
  if (client.includes('maxcredit')) {
    return 'maxcredit';
  }
  if (client.includes('sofi')) {
    return 'sofi';
  }
  if (client.includes('libramoneda')) {
    return 'libramoneda';
  }
  if (client.includes('qbcol')) {
    return 'quickbank';
  }
  if (client.includes('socialcredit')) {
    return 'socialcredit';
  }
  if (client.includes('cxc')) {
    return 'cxc';
  }
  if (client.includes('hazloya')) {
    return 'hazloya';
  }
  if (client.includes('pys')) {
    return 'pys';
  }
  if (client.includes('netwifi')) {
    return 'netwifi';
  }
  if (client.includes('credyfast')) {
    return 'credyfast';
  }
  if (client.includes('valit')) {
    return 'valit';
  }
  if (client.includes('trufi')) {
    return 'trufi';
  }
  if (client.includes('logicash')) {
    return 'logicash';
  }
  if (client.includes('krennova')) {
    return 'krennova';
  }

  return 'mili';
};
